import { themesMixin } from '../utils/themes';
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
  name: 'ViewLogin',
  directives: {
    disabledIconFocus: {
      bind(el) {
        el.querySelectorAll('.v-input__icon button').forEach(x => x.setAttribute('tabindex', -1));
      }
    }
  },
  mixins: [themesMixin],
  data: function () {
    return {
      showPage: false,
      valid: false,
      email: '',
      password: '',
      marker: false,
      tenantName: null,
      emailRules: [v => !!v, v => /.+@.+\..+/.test(v)],
      passwordRules: [v => !!v],
      submitted: false,
      homeRedirect: '/home',
      responsive: false,
      responsiveInput: false,
      showMfaInput: false,
      mfaToken: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'CustomTheme', 'UiTheme', 'loading']),
    loginLogo() {
      return this.themeGetLogoObject();
    },
    logoDefaultJustify() {
      if (this.logoPosition() === 'right') {
        return 'end';
      }
      if (this.logoPosition() === 'center') {
        return 'center';
      }
      return 'start';
    },
    loginLogoCenteredStyle() {
      if (this.isDefaultSvgLogo()) {
        return 'width: 134px; height: 40px;';
      }
      return `padding: 5px; width: ${this.loginLogo.orientation === 'square' ? 120 : 210}px; height: 120px;`;
    },
    loginBackground() {
      return this.themeGetBackground();
    },
    redirect() {
      if (this.$route.query.redirect) {
        return this.$route.query.redirect;
      }
      return null;
    },
    isOauth() {
      return this.$route.query.oauth ? true : false;
    },
    oauthSubdomainRedirectHref() {
      const host = window.location.hostname;
      const href = window.location.href;
      const lastLoginSubdomain = localStorage.getItem('lastLoginSubdomain');
      if (lastLoginSubdomain && lastLoginSubdomain !== host) {
        const url = href.replace(host, lastLoginSubdomain);
        return url;
      }
      return null;
    }
  },
  mounted() {
    // first attempt of loading, should have requested correct theming by now
    this.homeRedirect = this.$store.state.app.sidebarIconLink || '/home';
    document.getElementsByTagName('html')[0].classList.add('hide__scrollbar');
    if (this.isOauth && this.oauthSubdomainRedirectHref) {
      window.location.href = this.oauthSubdomainRedirectHref;
      return;
    }
    if (this.$route.query.token) {
      this.loginWithToken(this.$route.query.token).then(() => {
        this.$router.push(this.homeRedirect);
      }).catch(error => {
        this.showPage = true;
        if (error.response && this.this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.oauthTokenError'), 'error');
        }
      });
    } else if (this.$route.query.error) {
      this.showPage = true;
      switch (this.$route.query.error) {
        case 'oauth_user':
          this.$snack(this.$i18n_t('Common.errorOauthUserNotFound'), 'error');
          break;
      }
    } else {
      this.verify().then(() => {
        if (this.isOauth && this.redirect) {
          window.location.href = `${this.redirect}&token=${localStorage.getItem('token')}`;
          return;
        }
        this.$snack(this.$i18n_t('Common.welcomeBack'), 'success');
        this.$router.push(this.homeRedirect);
      }).catch(() => {
        // Do nothing
        this.showPage = true;
      });
    }
    this.onResponsiveInverted();
    window.addEventListener('resize', this.onResponsiveInverted);
  },
  beforeDestroy() {
    document.getElementsByTagName('html')[0].classList.remove('hide__scrollbar');
    window.removeEventListener('resize', this.onResponsiveInverted);
  },
  methods: {
    ...mapActions('authentication', ['login', 'loginWithToken', 'verify']),
    ...mapMutations('app', ['snackbar']),
    validate() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.snackbar = true;
      }
    },
    handleSubmit() {
      // for double good measure, re-load the sidebar-home-link here, if it exists
      this.homeRedirect = this.$store.state.app.sidebarIconLink || '/home';
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.validate();
      this.submitted = true;
      const {
        email,
        password,
        mfaToken,
        $router
      } = this;
      this.login({
        ...{
          username: email,
          password
        },
        ...(mfaToken && {
          token: mfaToken
        })
      }).then(() => {
        this.$snack(this.$i18n_t('Common.loggedIn'), 'success');
        this.$store.state.app.load = 100;
        this.$store.state.app.loading = false;
        if (this.isOauth && this.redirect) {
          // check if redirect is a valid url e.g. not javascript:alert('xss') or data:image/png;base64,i...
          const url = new URL(this.redirect);
          if (url.protocol !== 'http:' && url.protocol !== 'https:') {
            console.error('Invalid redirect URL:', this.redirect);
            this.$snack(this.$i18n_t('Common.invalidRedirect') || 'Invalid redirect URL', 'error');
            this.$router.push('/home');
            return;
          }
          window.location.href = `${this.redirect}&token=${localStorage.getItem('token')}`;
          return;
        }
        if (this.redirect) {
          $router.push(this.redirect);
          return;
        }
        $router.push(this.homeRedirect);
      }).catch(error => {
        this.$store.state.app.load = 100;
        this.$store.state.app.loading = false;
        if (error.data && error.data.message === '2FA_TOKEN_REQUIRED') {
          this.showMfaInput = true;
          return;
        } else if (error.data && this.$i18n_t(`Error.${error.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.data.message}`), 'error');
        } else if (error.data && !this.$i18n_t(`Error.${error.data.message}`)) {
          this.$snack(this.$i18n_t('Error.unknown'), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.credWrong'), 'error');
        }
      });
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    }
  }
};